import * as React from "react";

function SvgIcHide(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.293 4.293a1 1 0 011.414 0l1.95 1.95C8.878 5.506 10.33 5 12 5c2.332 0 4.239.984 5.674 2.211 1.429 1.22 2.433 2.716 3 3.86.323.652.223 1.379-.127 1.92l-.087.134c-.607.939-1.437 2.223-2.577 3.343l1.824 1.825a1 1 0 01-1.414 1.414l-14-14a1 1 0 010-1.414zm6.414 5L9.126 7.711A6.203 6.203 0 0112 7c1.736 0 3.198.725 4.375 1.731 1.166.997 2.01 2.237 2.485 3.184l-.037.058c-.634.98-1.375 2.124-2.354 3.082l-1.761-1.762a3 3 0 00-4.001-4.001zM6.12 8.728a1 1 0 01.164 1.404c-.496.628-.88 1.255-1.144 1.782C6.55 14.095 8.443 17 12 17c.58 0 1.11-.077 1.595-.21a1 1 0 01.531 1.928A7.962 7.962 0 0112 19c-4.668 0-7.106-3.777-8.432-5.831l-.115-.178a1.945 1.945 0 01-.126-1.922c.325-.656.79-1.418 1.389-2.176a1 1 0 011.404-.164z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgIcHide;
